<template>
    <el-form :model="ddctQrcodeInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">商户名称</label>
                </div>
                <div class="form-value width-3x">
                    <span>{{ddctQrcodeInfo.merchantName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">用途</label>
                </div>
                <div class="form-value width-3x">
                    <el-form-item prop="bizAspect">
                        <el-radio-group v-model="ddctQrcodeInfo.usage" @change="changeUsage">
                            <el-radio :label="1">入职</el-radio>
                            <el-radio :label="2">离职</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">机构名称</label>
                </div>
                <div class="form-value width-3x">
                    <el-input class="width-1-5x bottom-line" disabled type="text" v-model="ddctQrcodeInfo.comName"></el-input>
                    <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectComInfo()"></div>
                </div>
            </div>
            <div class="form-group center" v-if="ddctQrcodeInfo.usage == 1">
                <div class="form-label">
                    <label>岗位名称</label>
                </div>
                <div class="form-value width-3x">
                    <el-form-item prop="catName">
                        <el-input class="width-1-5x bottom-line" disabled type="text" v-model="ddctQrcodeInfo.roleName"></el-input>
                        <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectComRoleInfo()"></div>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>码上文字</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="name">
                        <el-input type="text" v-model="ddctQrcodeInfo.topTxt"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>码下文字</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="name">
                        <el-input type="text" v-model="ddctQrcodeInfo.btmTxt"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openRetailerComListForSelectDlg } from '../retailer/selectDlg'
    import { openRetailerComRoleDlg } from '../staffBiz/selectDlg'

    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'

    export default{
        name: 'swb-ddct-qrcode-save',
        desc: '专用二维码-保存',
        data: function () {
            return {
                ddctQrcodeInfo: {
                    usage: 1,
                },
                content: {},
                rules: {},
            }
        },
        created: function () {
            //
            this.getCurrentUserInfo();
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type == "info") {
                        let ddctQrcodeInfo = self.ddctQrcodeInfo;
                        let userInfo = result.data;
                        //
                        let scopeEntity = userInfo.scopeEntity;
                        ddctQrcodeInfo.merchantId = scopeEntity.id;
                        ddctQrcodeInfo.merchantType = scopeEntity.type;
                        ddctQrcodeInfo.merchantName = scopeEntity.name;
                        //
                        self.ddctQrcodeInfo = Utils.merge({}, ddctQrcodeInfo);
                    }
                });
            },
            // 切换用途
            changeUsage: function () {
                let ddctQrcodeInfo = this.ddctQrcodeInfo;
                //
                ddctQrcodeInfo.roleId = null;
                ddctQrcodeInfo.roleName = null;
                //
                this.ddctQrcodeInfo = Utils.merge({}, ddctQrcodeInfo);
            },
            selectComInfo: function () {
                let self = this;
                let queryFilter = {
                    checkBox: false,
                };
                openRetailerComListForSelectDlg(queryFilter, function (resultData, theDlg) {
                    theDlg.close();
                    let ddctQrcodeInfo = self.ddctQrcodeInfo;
                    //
                    self.isBizUnitFlag = resultData.orgType == 1;   // 是否业务单元
                    ddctQrcodeInfo.bizUnitId = resultData.bizUnitId;
                    ddctQrcodeInfo.bizUnitName = resultData.bizUnitName;
                    ddctQrcodeInfo.comId = resultData.id;
                    ddctQrcodeInfo.comName = resultData.name;
                    ddctQrcodeInfo.comLevel = resultData.level;
                    if(ddctQrcodeInfo.usage == 1) {
                        ddctQrcodeInfo.topTxt = "员工入职二维码";
                    } else {
                        ddctQrcodeInfo.topTxt = "员工离职二维码";
                    }
                    ddctQrcodeInfo.btmTxt = resultData.name;
                    //
                    self.ddctQrcodeInfo = Utils.merge({}, ddctQrcodeInfo);
                });
            },
            // 切换岗位信息
            selectComRoleInfo: function () {
                let self = this;
                let ddctQrcodeInfo = self.ddctQrcodeInfo;
                if(!Utils.isNoB(ddctQrcodeInfo.comId)) {
                    let comId = ddctQrcodeInfo.comId;
                    if(Utils.isTrue(this.isBizUnitFlag)) {
                        comId = null;
                    }
                    openRetailerComRoleDlg(ddctQrcodeInfo.bizUnitId, comId, function (result) {
                        ddctQrcodeInfo.comId = result.comId;
                        ddctQrcodeInfo.comName = result.comName;
                        ddctQrcodeInfo.comLevel = result.comLevel;
                        ddctQrcodeInfo.roleId = result.roleId;
                        ddctQrcodeInfo.roleName = result.roleName;
                        //
                        ddctQrcodeInfo.topTxt = "员工入职二维码";
                        ddctQrcodeInfo.btmTxt = result.roleName;
                        //
                        self.ddctQrcodeInfo = Utils.merge({}, ddctQrcodeInfo);
                    });
                } else {
                    MsgBox.warning("请选择机构！");
                }
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        let ddctQrcodeInfo = self.ddctQrcodeInfo;
                        if(!Utils.isNoB(ddctQrcodeInfo.comId)) {
                            //
                            let content = {
                                merchantId: ddctQrcodeInfo.merchantId,
                                merchantType: 3,    // 零售商
                                comId: ddctQrcodeInfo.comId,
                                comLevel: ddctQrcodeInfo.comLevel,
                                roleId: ddctQrcodeInfo.roleId || null
                            };
                            ddctQrcodeInfo.content = JSON.encode(content);
                            //
                            result.type = 'info';
                            result.data = ddctQrcodeInfo;
                        } else {
                            result.type = 'warn';
                            result.message = '请选择机构信息';
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/DdctQrcodeSave.vue